import { PageProps } from '@/types';
import { usePage } from '@inertiajs/react';
import { Point } from 'geojson';

export function useMapFeatures() {
    const props = usePage<PageProps>().props;

    const centerLocation = (props.centerLocation as Point | null) ?? null;
    const radius = (props.radius as number | null) ?? null;

    return { centerLocation, radius };
}
